import HttpService from './baseHttp'

//列表
export const HttpGetFuelSurchargeList = (data) => HttpService.get("/api/v1/carrierFuelSurcharge/findByPage", { params: data, baseURL: process.env.VUE_APP_APIURL_FBB }); 
//添加
export const HttpAddFuelSurcharge = (data) => HttpService.post("/api/v1/carrierFuelSurcharge/saveData", data, { headers: { "Content-Type": "application/json" }, baseURL: process.env.VUE_APP_APIURL_FBB });
//编辑
export const HttpEditFuelSurcharge = (data) => HttpService.post("/api/v1/carrierFuelSurcharge/update", data, { headers: { "Content-Type": "application/json" }, baseURL: process.env.VUE_APP_APIURL_FBB });
//删除
export const HttpDeleteFuelSurcharge = (data) => HttpService.get("/api/v1/carrierFuelSurcharge/delete", { params: data, baseURL: process.env.VUE_APP_APIURL_FBB });
//详情
export const HttpGetFuelSurcharge = (data) => HttpService.get("/api/v1/carrierFuelSurcharge/findOne", { params: data, baseURL: process.env.VUE_APP_APIURL_FBB });
